import React, { useCallback, useMemo, useState } from 'react';
import cx from 'classnames';
import Avatar from '../Avatar/Avatar';
import { useHistory, useLocation } from 'react-router-dom';
import { useUserContext } from '../../context/UserContext';
import styles from './EngageSidebar.module.scss';
import { DropDownMenu } from '../DropdownMenu/DropDownMenu';
import AvatarPlaceholder from '../../assets/avatarPlaceholder.png';
import configs from '../../../../conf';
import { isChrome, isEdge } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import Popover from 'react-tiny-popover';

const config = configs[process.env.APP_CONF];

export default function Profile(props) {
  const {
    children,
    mini,
    toggleMiniSettingLinks,
    isOpenMenu,
    setIsOpenMenu,
    miniSettingLinks,
    active,
    popover,
    allowAnimation,
    languages,
    language,
    setIsLanguageMenu,
    isShowCompanySettings,
    position,
    ...rest
  } = props;

  const { user, appConfig, isUserManagementEnabled } = useUserContext();

  const { userName, userAvatar, userEmail } = useMemo(() => {
    if (user) {
      const name = `${user.firstName}`;
      const avatar = user.avatarUri;
      const email = user.userEmail;
      return { userName: name, userAvatar: avatar, userEmail: email };
    }
    return {};
  }, [user]);

  const [isHover, setIsHover] = useState(false);
  const mediaMatch = window.matchMedia('(max-width: 900px)');
  const [isMobileView] = useState(mediaMatch.matches);
  const { t } = useTranslation();

  const toggleChat = () => {
    if ($crisp && $crisp?.is) {
      if (!$crisp.is('chat:opened')) {
        console.log('open CHAT');
        $crisp.push(['do', 'chat:show']);
        $crisp.push(['do', 'chat:open']);
      } else {
        $crisp.push(['do', 'chat:hide']);
        $crisp.push(['do', 'chat:close']);
      }
    }
  };

  const installLink = () => {
    if (isChrome) return { name: t('sidebar.profile.install_chrome_extension'), path: config.chromeWebStoreUrl };
    if (isEdge) return { name: t('sidebar.profile.install_edge_extension'), path: config.edgeWebStoreUrl };
  };

  const companySettings = useCallback(() => {
    if (isShowCompanySettings && !isMobileView) {
      return { name: t('company.settings.title'), path: '/eg/company-settings' };
    }
  }, [isShowCompanySettings]);

  const toggle = () => {
    setIsHover(false);
    setIsOpenMenu(!isOpenMenu);
  }
  const history = useHistory();
  const location = useLocation();
  const options = {
    settings: [{ name: t('sidebar.profile.account_settings'), path: '/eg/settings' }, companySettings()],
    help: [{ name: t('sidebar.profile.chat'), action: () => toggleChat() }],
    ...(isShowCompanySettings &&
      !isUserManagementEnabled && { management: [{ name: t('sidebar.user_management'), path: config.cmsUrl }] }),
    instruments: [
      { name: t('sidebar.profile.download_mobile_app'), path: '/eg/download' },
      installLink(),
      { name: t('sidebar.profile.install_desktop_app'), path: '/eg/download-center' },
    ],
    language: [{ name: t('sidebar.profile.set_language'), action: () => setIsLanguageMenu(true), flagImage: language.flagPath }],
    signOut: [{ name: t('sidebar.profile.sign_out'), path: '/logout' }],
  };

  const handleSelectOptions = useCallback(
    value => {
      if (value.startsWith('https', 0)) {
        window.open(value, '_blank');
      } else {
        location.pathname !== value && history.push(value);
      }
    },
    [history, location]
  );

  const handleAvatarClick = () => {
    if (user) {
      if (isMobileView) {
        history.push('/eg/settings');
      } else {
        toggle();
      }
    } else {
      console.log('redirect to login page');
    }
  };

  return (
    <Popover
      isOpen={popover !== null && isHover}
      position={['right']} // preferred position
      content={<div className={styles.popoverContainer}>{popover}</div>}
      containerStyle={{ zIndex: '999' }}
    >
      <div className={cx(styles.profile, { [styles.mini]: mini })} onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)} {...rest}>
        <DropDownMenu
          onSelect={handleSelectOptions}
          options={options}
          position={position ?? "top"}
          setIsOpen={setIsOpenMenu}
          toggle={toggle}
          selected={false}
          isOpen={isOpenMenu}
          selectable={false}
          data={user}
          mini={mini}
          className={styles.optionsMenu}
        >
          <p className={styles.dropDownUsername}>{userName}</p>
          <div>{userEmail}</div>
          {appConfig?.name && <div>{appConfig?.name}</div>}
        </DropDownMenu>
        <div className={cx(styles.sidebarSection, { [styles.mini]: mini, [styles.active]: active })} onClick={handleAvatarClick}>
          <Avatar image={user ? userAvatar : AvatarPlaceholder} title={userName} size="medium" alt="Show profile settings" />
          {mini ? null : <span className={cx(styles.name, styles.username)}>{user ? userName : t('sidebar.profile.sign_in')}</span>}
        </div>
      </div>
    </Popover>
  );
}
